import React from 'react';

export default function About() {
  return <div>Game dev for hire!</div>;
}
